import { Empty, Input, Typography } from 'antd';
import React, { forwardRef } from 'react';

import {
  useCountryList,
  useCountryListEffects,
} from '@app/components/Phone/hooks';
import type { CountryListProps } from '@app/components/Phone/types';
import { Flag } from '@app/components/Phone/ui';

import '@app/components/Phone/styles/CountryList.desktop.scss';

const PF = 'country-list';

const { Text } = Typography;

export const CountryList = forwardRef<HTMLDivElement, CountryListProps>(
  (props, ref) => {
    const {
      skipSearchHandler,
      onSelectHandler,
      handleSearchInputChange,
      filteredCountries,
      searchValue,
    } = useCountryList(props);

    useCountryListEffects({ skipSearchHandler });

    return (
      <div ref={ref} className={`${PF}_container`}>
        <Input
          name="phone_country_search"
          size="small"
          placeholder="Страна или код"
          value={searchValue}
          onChange={handleSearchInputChange}
          data-testid="country-code-search"
        />
        <div className={`${PF}_list`}>
          {filteredCountries.length > 0 ? (
            filteredCountries.map(({ Alpha2, Name, TelCode }) => (
              <div
                className={`${PF}_item`}
                key={Alpha2}
                onClick={() => onSelectHandler(Alpha2)}
              >
                <div className={`${PF}_item_left`}>
                  <Flag countryAlpha2={Alpha2} />
                  <Text data-testid="country-name">{Name}</Text>
                </div>
                <Text
                  type="secondary"
                  data-testid="country-code"
                >{`+${TelCode}`}</Text>
              </div>
            ))
          ) : (
            <Empty description="Страна не найдена" className={`${PF}_empty`} />
          )}
        </div>
      </div>
    );
  }
);

CountryList.displayName = 'CountryList';
